import { SchoolService } from "@/api/service-proxies";
export const schoolService = new SchoolService();